export default function NotFound() {
    return (
        <div>
            <h1 className={"not-found__title"}>We're sorry</h1>
            <h3 className={"not-found__message"}>Page not found. It looks like we can't find the page you're looking for. Maybe a quick search would help.</h3>
        </div>
    )
}